export default "__VITE_ASSET__3dd38ceb__"